export default __webpack_public_path__ + "static/media/Gray-Facebook.fb2e6817.svg";